import { Component, inject, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { LANGS } from '../../shared/constants/lang.constants';
import { ReactiveFormsModule } from '@angular/forms';
import { TextComponent } from '../../shared/components/text/text.component';
import { Router } from '@angular/router';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { CreateMemberRequest } from '../../shared/interfaces/set-password.model';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from "@angular/material/button";
import { ReportQueryService } from '../../shared/services/report-query.service';
import { HCReport, LatestReportRequest, LatestReportResponse, RecordList, ReportHistoryResponse } from '../../shared/interfaces/report-query.model';
import { ApiResponse } from '../../shared/interfaces/api-response.model';
import { FormatDateYearMonthDayPipe } from '../../pipes/format-date-year-month-day.pipe';
import { MatFormField } from "@angular/material/input";
import { MatSelect, MatOption, MatSelectTrigger } from "@angular/material/select";
import { KendoComponent } from '../../shared/components/kendo/kendo/kendo.component';
import { KENDO_CHARTS } from '@progress/kendo-angular-charts';
/**
 * 我的健檢與歷年報告
 */
@Component({
  selector: 'app-my-reports',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TextComponent,
    TranslatePipe,
    MatButton,
    FormatDateYearMonthDayPipe,
    MatFormField,
    MatSelect,
    MatOption,
    MatSelectTrigger,
    KendoComponent,
    KENDO_CHARTS

],
  templateUrl: './my-reports.component.html',
  styleUrl: './my-reports.component.scss',
})
export class MyReportsComponent {
  @ViewChild('reportLeftCart', { static: false }) reportLeftCart?: ElementRef;
  LANGS = LANGS;
  router: Router = inject(Router);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  createMemberRequest: CreateMemberRequest | null = null;
  isLoading: boolean = false;
  noData: boolean = false;
  noReportData: boolean = false;
  @Input() selectedTab: number = 0;
  currentPage = 1;
  pageSize = 5;
  status = ''; // 報告狀態
  selectedCategory: string = 'all'; // 改為 'all' 表示顯示全部
  reportQueryService: ReportQueryService = inject(ReportQueryService);
  examCategories: Array<{ examItem: string; name: string; hasAlert: boolean }> = [];
  // 歷年檢項數值紀錄
  historicalExamRecords: RecordList[] = [];

  latestReportResponse: LatestReportResponse | null = null;
  
  isReportCartOpen = false;
  historicalRecords: any[] = [];
  // 當前選中要查看歷年紀錄的檢項
  selectedExamForHistory: any = null;

  constructor(private renderer: Renderer2) {}
  
  // 假資料 - CB-023 歷年健檢報告
  allReports: HCReport[] =  [
    // {
    //   "caseNo": "201234567",
    //   "bookDate": "20200701",
    //   "bookStatus": "1"
    // },
    // {
    //   "caseNo": "123456789",
    //   "bookDate": "20190701",
    //   "bookStatus": "8"
    // },
    // {
    //   "caseNo": "123456780",
    //   "bookDate": "20180701",
    //   "bookStatus": "9"
    // }
  ];
  
  
  // 假資料 - CB-054
//   mockData: ApiResponse<LatestReportResponse> = {
//   "success": true,
//   "statusCode": "S0000",
//   "data": {
//     "orgNo": "01",
//     "bookDate": "20260414",
//     "deptList": [
//       {
//         "deptName": "一般檢查",
//         "deptEName": "General  Examination",
//         "examItemList": [
//           {
//             "examItem": "PE00010001",
//             "examName": "身高",
//             "examEName": "Body Height",
//             "rValue": "173.8",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010002",
//             "examName": "體重",
//             "examEName": "Body Weight",
//             "rValue": "72.0",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010017",
//             "examName": "腰圍",
//             "examEName": "Waistline",
//             "rValue": "84",
//             "warnFlag": "0",
//             "refData": "<=90 (公分(cm))",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010019",
//             "examName": "體脂肪率",
//             "examEName": "Body Fat Percentage",
//             "rValue": "18.8",
//             "warnFlag": "0",
//             "refData": "17-23 (%)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010003",
//             "examName": "理想體重",
//             "examEName": "Ideal Body Weight",
//             "rValue": "66.5",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010006",
//             "examName": "身體質量指數",
//             "examEName": "Body Mass Index",
//             "rValue": "23.8",
//             "warnFlag": "0",
//             "refData": "18.50 - 23.99 (Kg/㎡)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010009",
//             "examName": "坐姿收縮壓",
//             "examEName": "SBP,Sitting",
//             "rValue": "112",
//             "warnFlag": "0",
//             "refData": "<130 (mmHg)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010010",
//             "examName": "坐姿舒張壓",
//             "examEName": "DBP, sitting",
//             "rValue": "65",
//             "warnFlag": "0",
//             "refData": "<85 (mmHg)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010007",
//             "examName": "脈搏數",
//             "examEName": "Pulse Rate",
//             "rValue": "59",
//             "warnFlag": "0",
//             "refData": "50 - 100 (次/分(/min))",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00010008",
//             "examName": "脈搏節律",
//             "examEName": "Rhythm",
//             "rValue": "規則 (Regular Rhythm of Pulsation)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           }
//         ]
//       },
//       {
//         "deptName": "理學檢查",
//         "deptEName": "Physical  Examination",
//         "examItemList": [
//           {
//             "examItem": "HI000001",
//             "examName": "自覺症狀",
//             "examEName": "Chief Complaints",
//             "rValue": "無",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "HI000002",
//             "examName": "既往病史",
//             "examEName": "Past Medical History",
//             "rValue": "既往病史：無 手術史或重大外傷：無 長期服用藥物：無",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "HI000003",
//             "examName": "家族病史",
//             "examEName": "Family History",
//             "rValue": "祖母肝癌",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010025",
//             "examName": "頭頸部",
//             "examEName": "Head And Neck",
//             "rValue": "無異狀 (Conjunctiva:Not pale;Sclera:Not icteric;Neck:Supple.No carotid bruit;Thyroid:No enlarged)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010026",
//             "examName": "呼吸系統",
//             "examEName": "Lung Examination",
//             "rValue": "無異狀 (Lung:Clear Breathing Sound)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010027",
//             "examName": "心臟血管系統",
//             "examEName": "Cardiovascular System",
//             "rValue": "無異狀 (Heart:Regular beats,no murmur)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010028",
//             "examName": "消化系統",
//             "examEName": "Digestive System",
//             "rValue": "無異狀 (Abdomen:Liver/Spleen impalpable,no tenderness)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010029",
//             "examName": "神經系統",
//             "examEName": "Neurology",
//             "rValue": "無異狀 (Nervous system(Sensory;Sleeping):Not Remarkable)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010030",
//             "examName": "肌肉骨骼",
//             "examEName": "Skeletal System",
//             "rValue": "無異狀 (Extremities: Free and Normal Range of Motion)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00010031",
//             "examName": "皮膚",
//             "examEName": "Skin",
//             "rValue": "無異狀 (Skin:No remarkable)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "HI000008",
//             "examName": "嚼檳榔習慣",
//             "examEName": "Habit of Chewing Betel Nuts",
//             "rValue": "最近六個月內是否有嚼食檳榔：從未嚼食檳榔",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "HI000006",
//             "examName": "吸菸習慣",
//             "examEName": "Smoking Habit",
//             "rValue": "最近一個月內是否有吸菸：從未吸菸",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "HI000007",
//             "examName": "飲酒習慣",
//             "examEName": "Drinking Habit",
//             "rValue": "最近一個月內是否有喝酒：偶爾(不是天天)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "HI000009",
//             "examName": "運動習慣",
//             "examEName": "Exercise Habit",
//             "rValue": "運動習慣：每週1~2次 每次運動時間：半小時~1小時 常做運動型態：中度(如有氧舞蹈)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           }
//         ]
//       },
//       {
//         "deptName": "肺部檢查",
//         "deptEName": "Lung Examination",
//         "examItemList": [
//           {
//             "examItem": "R1010100",
//             "examName": "胸部X光（正面）",
//             "examEName": "Chest X-ray,PA view",
//             "rValue": "No Active Lung Lesion",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R101010001",
//             "examName": "胸部X光（正面）報告摘錄",
//             "examEName": "Chest X-ray,PA view",
//             "rValue": "無活動性肺部病變 (No Active Lung Lesion)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           }
//         ]
//       },
//       {
//         "deptName": "心血管及代謝系統",
//         "deptEName": "Cardiovascular and Metabolic System",
//         "examItemList": [
//           {
//             "examItem": "L3002000",
//             "examName": "三酸甘油酯",
//             "examEName": "Triglyceride",
//             "rValue": "75",
//             "warnFlag": "0",
//             "refData": "<150 (mg/dL)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "L3001900",
//             "examName": "總膽固醇",
//             "examEName": "Total cholesterol",
//             "rValue": "147",
//             "warnFlag": "0",
//             "refData": "< 200 (mg/dL)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "L3003500",
//             "examName": "高密度脂蛋白-膽固醇",
//             "examEName": "HDL-C",
//             "rValue": "44",
//             "warnFlag": "0",
//             "refData": ">40 (mg/dL)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "L3005200",
//             "examName": "低密度脂蛋白-膽固醇",
//             "examEName": "LDL-C",
//             "rValue": "96",
//             "warnFlag": "0",
//             "refData": "< 130 (mg/dL)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "L300350001",
//             "examName": "總/高密度膽固醇比",
//             "examEName": "Total/HDL Ratio",
//             "rValue": "3.34",
//             "warnFlag": "0",
//             "refData": "<5",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L300350002",
//             "examName": "低/高密度脂蛋白比值",
//             "examEName": "LDL/HDL ratio",
//             "rValue": "2.18",
//             "warnFlag": "0",
//             "refData": "<3",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3000800",
//             "examName": "飯前血糖",
//             "examEName": "Fasting blood sugar",
//             "rValue": "91",
//             "warnFlag": "0",
//             "refData": "70-99 (mg/dL)",
//             "isChart": true,
//             "isNum": true
//           },
//           {
//             "examItem": "L3018400",
//             "examName": "高敏感性C反應蛋白",
//             "examEName": "hs-CRP",
//             "rValue": "0.038",
//             "warnFlag": "0",
//             "refData": "< 0.1 (mg/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "R202600001",
//             "examName": "甲狀腺超音波報告摘錄",
//             "examEName": "Thyroid ECHO",
//             "rValue": "雙側甲狀腺無異狀(Bilateral Thyroid Negative Finding)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "L10011002",
//             "examName": "平均心室率",
//             "examEName": "Mean Ventricular Rate",
//             "rValue": "57",
//             "warnFlag": "0",
//             "refData": "50 - 100 (次/分(/min))",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L10011003",
//             "examName": "靜式心電圖報告摘錄",
//             "examEName": "Resting EKG",
//             "rValue": "ST波上升,疑正常早期再極化(ST Wave Elevation, Probable Normal Early Repolarization Pattern)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R4014710",
//             "examName": "周邊動脈硬化評估",
//             "examEName": "Assessment of Atherosclerosis",
//             "rValue": "無異狀",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R401471001",
//             "examName": "右臂脈波傳導速度",
//             "examEName": "RbaPWV",
//             "rValue": "1354",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "R401471002",
//             "examName": "左臂脈波傳導速度",
//             "examEName": "LbaPWV",
//             "rValue": "1340",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "R401471003",
//             "examName": "右側踝臂血壓指數",
//             "examEName": "Rabi",
//             "rValue": "1.08",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "R401471004",
//             "examName": "左側踝臂血壓指數",
//             "examEName": "Labi",
//             "rValue": "1.12",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "R401471005",
//             "examName": "右側周邊血管彈性",
//             "examEName": "Right side of the peripheral vascular elasticity",
//             "rValue": "無異狀(baPWV 參考值＜ 1400 cm/s)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R401471006",
//             "examName": "左側周邊血管彈性",
//             "examEName": "Left side of the peripheral vascular elasticity",
//             "rValue": "無異狀(baPWV 參考值＜ 1400 cm/s)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R401471007",
//             "examName": "右側周邊血管阻塞程度",
//             "examEName": "Peripheral vascular occlusion of the right",
//             "rValue": "無異狀(ABI 參考值 0.9-1.4)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R401471008",
//             "examName": "左側周邊血管阻塞程度",
//             "examEName": "Peripheral vascular occlusion of the left",
//             "rValue": "無異狀(ABI 參考值 0.9-1.4)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "R401470005",
//             "examName": "十年心血管疾病風險評估",
//             "examEName": "The 10-year Cardiovascular Assessment",
//             "rValue": "計算結果為 1.2%；若您有已知之心血管疾病或患有糖尿病，無論計算後之心血管疾病發生率多少，您皆視同為高危險族群 （10年危險性＞20%）",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           }
//         ]
//       },
//       {
//         "deptName": "消化系統",
//         "deptEName": "Digestive System",
//         "examItemList": [
//           {
//             "examItem": "L3000200",
//             "examName": "麩胺酸苯醋酸轉氨基酶",
//             "examEName": "GOT, AST",
//             "rValue": "14",
//             "warnFlag": "0",
//             "refData": "5-35 (IU/L)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3000300",
//             "examName": "麩胺酸丙酮酸轉氨基酶",
//             "examEName": "GPT, ALT",
//             "rValue": "9",
//             "warnFlag": "0",
//             "refData": "5-35 (IU/L)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3001800",
//             "examName": "總蛋白",
//             "examEName": "Total protein",
//             "rValue": "6.4",
//             "warnFlag": "0",
//             "refData": "6.3-8.5 (g/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L301810002",
//             "examName": "白蛋白",
//             "examEName": "Albumin",
//             "rValue": "4.5",
//             "warnFlag": "0",
//             "refData": "3.5-5.2 (g/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L301810003",
//             "examName": "球蛋白",
//             "examEName": "Globulin",
//             "rValue": "1.90",
//             "warnFlag": "0",
//             "refData": "2.5-3.6 (g/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L301810001",
//             "examName": "白蛋白/球蛋白比例",
//             "examEName": "A/G ratio",
//             "rValue": "2.4",
//             "warnFlag": "1",
//             "refData": "1.2-2",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3000400",
//             "examName": "麩胺酸轉肽酶",
//             "examEName": "γ-GT",
//             "rValue": "9",
//             "warnFlag": "0",
//             "refData": "8-61 (IU/L)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3000100",
//             "examName": "鹼性磷酸酶",
//             "examEName": "Alkaline phosphatase",
//             "rValue": "53",
//             "warnFlag": "0",
//             "refData": "40-129 (U/L)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3001700",
//             "examName": "總膽紅素",
//             "examEName": "Total bilirubin",
//             "rValue": "0.8",
//             "warnFlag": "0",
//             "refData": "0.2-1.2 (mg/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3001710",
//             "examName": "直接膽紅素",
//             "examEName": "Direct bilirubin",
//             "rValue": "0.4",
//             "warnFlag": "1",
//             "refData": "0.1-0.5 (mg/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L6000800",
//             "examName": "胰澱粉酶",
//             "examEName": "Amylase",
//             "rValue": "35",
//             "warnFlag": "0",
//             "refData": "28-100 (IU/L)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L4002800",
//             "examName": "潛血（酵素免疫）",
//             "examEName": "OB, EIA",
//             "rValue": "Negative",
//             "warnFlag": "0",
//             "refData": "Negative (ng/mL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "R202200001",
//             "examName": "腹部超音波檢查報告摘錄",
//             "examEName": "Upper Abdominal  Sonography Findings",
//             "rValue": "腸氣過多影響判讀 (Some views are obscured by bowel gas)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           }
//         ]
//       },
//       {
//         "deptName": "腎臟泌尿系統",
//         "deptEName": "Kidney and Urology",
//         "examItemList": [
//           {
//             "examItem": "L3001300",
//             "examName": "尿素氮",
//             "examEName": "Blood urea nitrogen",
//             "rValue": "10",
//             "warnFlag": "0",
//             "refData": "8-25 (mg/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3001400",
//             "examName": "尿酸",
//             "examEName": "Uric acid",
//             "rValue": "6.9",
//             "warnFlag": "0",
//             "refData": "3.4-7 (mg/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L3001500",
//             "examName": "肌酸酐",
//             "examEName": "Creatinine",
//             "rValue": "1.13",
//             "warnFlag": "0",
//             "refData": "0.7-1.2 (mg/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L300150001",
//             "examName": "腎絲球過濾率",
//             "examEName": "eGFR",
//             "rValue": "76",
//             "warnFlag": "1",
//             "refData": "≧ 90 (mL/min/1.73M^2)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200001",
//             "examName": "外觀",
//             "examEName": "Appearance",
//             "rValue": "Light-Yellow/Clear",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200002",
//             "examName": "尿糖",
//             "examEName": "Glucose",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": " - ",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200003",
//             "examName": "尿膽紅素",
//             "examEName": "Bilirubin",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": " - ",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200004",
//             "examName": "尿酮",
//             "examEName": "Ketone",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": "- ",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200005",
//             "examName": "尿比重",
//             "examEName": "Specific gravity",
//             "rValue": "1.013",
//             "warnFlag": "0",
//             "refData": "1.005-1.03",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200006",
//             "examName": "尿潛血",
//             "examEName": "Occult Blood",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": "( - ) - ( ± )",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200007",
//             "examName": "酸鹼值",
//             "examEName": "PH",
//             "rValue": "6.0",
//             "warnFlag": "0",
//             "refData": "5-8",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200008",
//             "examName": "尿蛋白",
//             "examEName": "Protein",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": "( - ) - ( ± )",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200009",
//             "examName": "尿膽素原",
//             "examEName": "Urobilinogen",
//             "rValue": "<1.5",
//             "warnFlag": "0",
//             "refData": "<1.5",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200010",
//             "examName": "亞硝酸鹽",
//             "examEName": "Nitrite",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": "( - )",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400200011",
//             "examName": "白血球",
//             "examEName": "Leukocyte",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": "( - ) - ( ± )",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400020001",
//             "examName": "紅血球",
//             "examEName": "Red blood cell",
//             "rValue": "0-3",
//             "warnFlag": "0",
//             "refData": "0-3 (/HPF)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400020002",
//             "examName": "白血球",
//             "examEName": "White blood cell",
//             "rValue": "0-5",
//             "warnFlag": "0",
//             "refData": "0-5 (/HPF)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400020003",
//             "examName": "表皮細胞",
//             "examEName": "Epithelial cell",
//             "rValue": "0-5",
//             "warnFlag": "0",
//             "refData": "0-5 (/HPF)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L400020007",
//             "examName": "微生物",
//             "examEName": "Microorganism",
//             "rValue": "-",
//             "warnFlag": "0",
//             "refData": "-",
//             "isChart": false,
//             "isNum": true
//           }
//         ]
//       },
//       {
//         "deptName": "血液系統",
//         "deptEName": "Hematology",
//         "examItemList": [
//           {
//             "examItem": "L5000400",
//             "examName": "白血球",
//             "examEName": "Leukocytes",
//             "rValue": "5.43",
//             "warnFlag": "0",
//             "refData": "4-10 (x10^3/μL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000300",
//             "examName": "紅血球",
//             "examEName": "Erythrocytes",
//             "rValue": "4.72",
//             "warnFlag": "0",
//             "refData": "4.7-6.1 (x10^6/μL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000100",
//             "examName": "血紅素",
//             "examEName": "Hemoglobin",
//             "rValue": "14.2",
//             "warnFlag": "0",
//             "refData": "14.0-18.0 (g/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000200",
//             "examName": "血球比容",
//             "examEName": "Hematocrit",
//             "rValue": "39.9",
//             "warnFlag": "1",
//             "refData": "42-52 (%)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000600",
//             "examName": "平均紅血球容積",
//             "examEName": "MCV",
//             "rValue": "84.5",
//             "warnFlag": "0",
//             "refData": "81.0 - 97.0 (fL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000700",
//             "examName": "平均紅血球血色素量",
//             "examEName": "MCH",
//             "rValue": "30.1",
//             "warnFlag": "0",
//             "refData": "26-34 (Pg)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000800",
//             "examName": "平均紅血球血色素濃度",
//             "examEName": "MCHC",
//             "rValue": "35.6",
//             "warnFlag": "0",
//             "refData": "31-36 (g/dL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L500320001",
//             "examName": "紅血球體積分佈寬度",
//             "examEName": "RDW",
//             "rValue": "11.3",
//             "warnFlag": "1",
//             "refData": "11.5-14.5 (%)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L5000900",
//             "examName": "血小板",
//             "examEName": "Platelet",
//             "rValue": "259",
//             "warnFlag": "0",
//             "refData": "130-400 (x10^3/μL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L500050001",
//             "examName": "嗜中性球",
//             "examEName": "Neutrophil",
//             "rValue": "59.4",
//             "warnFlag": "0",
//             "refData": "40-75 (%)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L500050002",
//             "examName": "淋巴球",
//             "examEName": "Lymphocyte",
//             "rValue": "30.6",
//             "warnFlag": "0",
//             "refData": "20-45 (%)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L500050003",
//             "examName": "單核球",
//             "examEName": "Monocyte",
//             "rValue": "5.7",
//             "warnFlag": "0",
//             "refData": "2.0-10 (%)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L500050004",
//             "examName": "嗜酸性球",
//             "examEName": "Eosinophil",
//             "rValue": "3.7",
//             "warnFlag": "0",
//             "refData": "0-7 (%)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "L500050005",
//             "examName": "嗜鹼性球",
//             "examEName": "Basophil",
//             "rValue": "0.6",
//             "warnFlag": "0",
//             "refData": "0-1 (%)",
//             "isChart": false,
//             "isNum": true
//           }
//         ]
//       },
//       {
//         "deptName": "腫瘤標記",
//         "deptEName": "Tumor Biomarker",
//         "examItemList": [
//           {
//             "examItem": "LI004500",
//             "examName": "甲種胎兒蛋白",
//             "examEName": "Alpha-fetoprotein",
//             "rValue": "1.53",
//             "warnFlag": "0",
//             "refData": "0-7 (ng/mL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "LI001600",
//             "examName": "癌胚胎抗原",
//             "examEName": "CEA",
//             "rValue": "2.0",
//             "warnFlag": "0",
//             "refData": "0-4.7 (ng/mL)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "LI004100",
//             "examName": "CA199腫瘤標記",
//             "examEName": "CA19-9",
//             "rValue": "19.1",
//             "warnFlag": "0",
//             "refData": "0-27 (U/mL)",
//             "isChart": false,
//             "isNum": true
//           }
//         ]
//       },
//       {
//         "deptName": "眼科檢查",
//         "deptEName": "Eye Examination",
//         "examItemList": [
//           {
//             "examItem": "PE00040001",
//             "examName": "右眼視力",
//             "examEName": "Right Eye",
//             "rValue": "1.0",
//             "warnFlag": "0",
//             "refData": "0.7 - 2.0",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00040002",
//             "examName": "左眼視力",
//             "examEName": "Left Eye",
//             "rValue": "1.0",
//             "warnFlag": "0",
//             "refData": "0.7 - 2.0",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE000400031",
//             "examName": "檢查方法",
//             "examEName": "Media of Examination",
//             "rValue": "配戴眼鏡 (Wear Eyeglasses)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00040003",
//             "examName": "視力判定",
//             "examEName": "Interpretation of Visual Acuity",
//             "rValue": "無明顯異常 (No Special Abnormal Findings)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00040004",
//             "examName": "右眼眼壓",
//             "examEName": "Right Eye",
//             "rValue": "16",
//             "warnFlag": "0",
//             "refData": "9 - 21 (mmHg)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00040005",
//             "examName": "左眼眼壓",
//             "examEName": "Left Eye",
//             "rValue": "15",
//             "warnFlag": "0",
//             "refData": "9 - 21 (mmHg)",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "PE00040006",
//             "examName": "眼壓判定",
//             "examEName": "Interpretation of Ocular Acuity",
//             "rValue": "無異狀 (Negative)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           },
//           {
//             "examItem": "PE00040014",
//             "examName": "石原色覺檢查表",
//             "examEName": "Ishihara Test for Color vision",
//             "rValue": "正常 (Normal)",
//             "warnFlag": "0",
//             "refData": "",
//             "isChart": false,
//             "isNum": false
//           }
//         ]
//       },
//       {
//         "deptName": "耳鼻喉科檢查",
//         "deptEName": "ENT Examination",
//         "examItemList": [
//           {
//             "examItem": "T700110011",
//             "examName": "500 赫茲",
//             "examEName": "500 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110012",
//             "examName": "1000 赫茲",
//             "examEName": "1000 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110013",
//             "examName": "2000 赫茲",
//             "examEName": "2000 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110014",
//             "examName": "4000 赫茲",
//             "examEName": "4000 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110015",
//             "examName": "500 赫茲",
//             "examEName": "500 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110016",
//             "examName": "1000 赫茲",
//             "examEName": "1000 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110017",
//             "examName": "2000 赫茲",
//             "examEName": "2000 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           },
//           {
//             "examItem": "T700110018",
//             "examName": "4000 赫茲",
//             "examEName": "4000 Hz",
//             "rValue": "Y",
//             "warnFlag": "0",
//             "refData": "Y",
//             "isChart": false,
//             "isNum": true
//           }
//         ]
//       }
//     ]
//   },
//   "timestamp": "2026-04-14T09:00:00Z"
// };

  ngOnInit() {
    this.isLoading = true;

    this.createMemberRequest = this.sharedStorageService.get('createMemberRequest') || null;

    // 待後端開發完開啟
    this.getLatestReport();

    // 取的近五年健檢報告
    this.getAllReports();
    
    // 使用 mockData 建立檢項分類
    // if (this.mockData.data) {
    //   this.examCategories = this.buildCategoriesFromMockData(this.mockData.data);

    //   if (window.innerWidth <= 768 && this.examCategories.length > 0) {
    //     this.selectedCategory = this.examCategories[0].examItem;
    //   } else {
    //     // 預設不選擇任何分類,顯示所有分類
    //     this.selectedCategory = '';
    //   }
    // }
  }
  
  get totalPages(): number {
    return Math.ceil(this.allReports.length / this.pageSize);
  }
  
  get paginatedReports(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.allReports.slice(start, start + this.pageSize);
  }
  
  get displayPages(): (number | string)[] {
    const pages: (number | string)[] = [];
    const total = this.totalPages;
    
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    
    pages.push(1);
    
    if (this.currentPage > 3) {
      pages.push('...');
    }
    
    for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(total - 1, this.currentPage + 1); i++) {
      pages.push(i);
    }
    
    if (this.currentPage < total - 2) {
      pages.push('...');
    }
    
    pages.push(total);
    
    return pages;
  }
  
  // 前往欲前往的頁數
  goToPage(page: number | string): void {
    if (typeof page === 'number') {
      this.currentPage = page;
    }
  }
  
  // 返回上一頁
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  // 前往下一頁
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }
  
  // CB-024 下載報告
  downloadReport(caseNo: string): void {
    // 下載報告邏輯
    this.reportQueryService.downloadReport(caseNo).then(() => {
      console.log('報告下載成功');
    }).catch((error) => {
      console.error('報告下載失敗', error);
    });
  }
  
  // 取得檢項分類
  selectCategory(examItem: string): void {
    this.selectedCategory = examItem;
  }

  // 取得分類名稱
  get selectedCategoryName(): string {
    if (this.selectedCategory === 'all') {
      return '全部檢查項目';
    }
    const category = this.examCategories.find(cat => cat.examItem === this.selectedCategory);
    return category?.name ?? '';
  }

  // 開啟歷年紀錄側邊欄
  openReportCart(exam?: any): void {
    console.log('openReportCart 被呼叫', exam);

    if (exam) {
      // API 好了之後改用這個:
      this.getReportHistory(exam.examItem, exam.isChart);

      // 取得歷年該檢項數值資料
      this.loadHistoricalData(exam.examItem);
    }
  }

  // 切換側邊欄
  toggleReportCart(): void {
    console.log('toggleReportCart 被呼叫');
    this.isReportCartOpen = !this.isReportCartOpen;
    
    const cartEl = this.reportLeftCart?.nativeElement;

    if (cartEl) {
      cartEl.classList.toggle('active');
      // 移除 body overflow 的設定,允許背景滾動
    }
  }

  // 載入歷年數據 - 假資料,實際應從後端取得 CB-055 的回應資料
  private loadHistoricalData(examItem: string): void {
    let examInfo: any = null;
    
    if (this.latestReportResponse) {
      for (const dept of this.latestReportResponse.deptList || []) {
        const found = dept.examItemList?.find(item => item.examItem === examItem);
        if (found && found.resultList && found.resultList.length > 0) {
          // 取第一筆 resultList 作為顯示資料
          const firstResult = found.resultList[0];
          examInfo = {
            examItem: found.examItem,
            name: found.examName,
            nameEn: found.examEName || '',
            refData: firstResult.refData || '',
            rValue: firstResult.rValue || '',
            isAbnormal: firstResult.warnFlag === '1',
            isNum: firstResult.isNum || false,
            isChart: firstResult.isChart || false
          };
          break;
        }
      }
    }
    
    // 儲存選中的檢項資訊
    this.selectedExamForHistory = examInfo;

    console.log('選中的檢項資訊:', this.selectedExamForHistory);
    
    // 直接賦值 recordList 陣列
    // this.historicalExamRecords = [
    //   {
    //     "bookDate": "20250807",
    //     "rValue": "",
    //     "warnFlag": "0"
    //   },
    //   {
    //     "bookDate": "20240805",
    //     "rValue": "",
    //     "warnFlag": "0"
    //   },
    //   {
    //     "bookDate": "20130903",
    //     "rValue": "正常 (Normal)",
    //     "warnFlag": "0"
    //   },
    //   {
    //     "bookDate": "20120927",
    //     "rValue": "正常 (Normal)",
    //     "warnFlag": "0"
    //   }
    // ];
    
    // 開啟側邊欄
    this.isReportCartOpen = true;
    const cartEl = this.reportLeftCart?.nativeElement;
    if (cartEl) {
      cartEl.classList.add('active');
    }
  }

  // call CB-054 查詢客戶最新報告資料
  getLatestReport() {
    const request: LatestReportRequest = {
      idNo: this.createMemberRequest?.idNo || '',
    };
    this.reportQueryService.getLatestReport(request).subscribe({
      next: (response) => {
        // 處理回應
        if (response.statusCode === 'S0000' && response.data) {
          // 取得報告 status
          this.status = response.data.bookStatus;
          if (response.data.deptList.length > 0) {

            this.latestReportResponse = response.data;
            // 建立檢項分類 - 需要將回傳值賦值給 examCategories
            this.examCategories = this.buildCategoriesData(this.latestReportResponse);

            if (window.innerWidth <= 768 && this.examCategories.length > 0) {
              this.selectedCategory = this.examCategories[0].examItem;
            } else {
              // 預設不選擇任何分類,顯示所有分類
              this.selectedCategory = '';
            }
          }
        } else if (response.statusCode === 'EL1017') {
          this.noReportData = true;
        }
        this.isLoading = false;
      },
      error: (error) => {
        // 處理錯誤
        console.error('取得最新報告失敗:', error);
        this.isLoading = false;
        this.noReportData = true;
      }
    });
  }

  buildCategoriesData(data: LatestReportResponse): Array<{ examItem: string; name: string; hasAlert: boolean }> {
    const categories: Array<{ examItem: string; name: string; hasAlert: boolean }> = [];

    // 從 deptList 取得分類
    data.deptList?.forEach((dept) => {
      // 檢查該分類下是否有任何檢項的任何結果為異常
      const hasAlert = dept.examItemList?.some(item => 
        item.resultList?.some(result => result.warnFlag === '1')
      ) || false;
      
      categories.push({
        examItem: dept.deptName,
        name: dept.deptName,
        hasAlert: hasAlert
      });
    });

    return categories;
  }

  getExamsByCategory(examItem: string): any[] {
    if (!this.latestReportResponse) return [];
    
    // 如果是 'all',返回空陣列(因為模板會自己遍歷所有分類)
    if (examItem === 'all') return [];
    
    // 從 deptList 找到對應的分類
    const dept = this.latestReportResponse.deptList?.find(d => d.deptName === examItem);
    
    if (!dept) return [];
    
    // 將 examItemList 展開,每個 resultList 項目都轉換成獨立的檢項
    const exams: any[] = [];

    dept.examItemList?.forEach(item => {
      // 遍歷該檢項的所有 resultList
      item.resultList?.forEach(result => {
        exams.push({
          examItem: item.examItem,
          name: item.examName,
          nameEn: item.examEName || '',
          value: result.rValue || '',
          refData: result.refData || '',
          isAbnormal: result.warnFlag === '1',
          isChart: result.isChart || false,
          isNum: result.isNum || false
        });
      });
    });

    return exams;
  }

  // 判斷是否顯示所有分類
  get isShowAllCategories(): boolean {
    return !this.selectedCategory;
  }

  // 取得單一分類的檢項
  getCategoryExams(deptName: string): any[] {
    if (!this.latestReportResponse) return [];
    
    const dept = this.latestReportResponse.deptList?.find(d => d.deptName === deptName);
    if (!dept) return [];
    
    return dept.examItemList?.map(item => {
      // 取第一筆 resultList 作為顯示資料
      const firstResult = item.resultList?.[0];
      
      return {
        examItem: item.examItem,
        name: item.examName,
        nameEn: item.examEName || '',
        value: firstResult?.rValue || '',
        refData: firstResult?.refData || '',
        isAbnormal: firstResult?.warnFlag === '1',
        isChart: firstResult?.isChart || false,
        isNum: firstResult?.isNum || false
      };
    }) || [];
  }


  // CB-055 查詢客戶檢項歷年紀錄
  getReportHistory(examItem: string, isChart: boolean) {
    const request = {
      idNo: this.createMemberRequest?.idNo ?? '',
      gender: this.createMemberRequest?.gender ?? '',
      orgNo: this.latestReportResponse?.orgNo ?? this.sharedStorageService.get('userPlanRequest')?.orgNo ?? '',
      examItem: examItem,
      isChart: isChart
    }

    this.reportQueryService.getReportHistory(request).subscribe({
      next: (response) => {
        if (response.statusCode === 'S0000' && response.data) {
          // 將 recordList 展開,處理每筆記錄的 resultList
          this.historicalExamRecords = response.data?.recordList?.map(record => ({
            bookDate: record.bookDate,
            resultList: record.resultList || []
          })) || [];
          
          this.isReportCartOpen = true;
          console.log('轉換後的歷年紀錄:', this.historicalExamRecords);
          const cartEl = this.reportLeftCart?.nativeElement;
          if (cartEl) {
            cartEl.classList.add('active');
          }
        }
      },
      error: (error) => {
        console.error('查詢歷年紀錄失敗', error);
      }
    });
  }

  // CB - 023 查詢所有健檢報告
  getAllReports() {
    const request = {
      idNo: this.createMemberRequest?.idNo || '',
      range: '5' // 固定帶 5,代表查詢近五年的報告
    }
    this.reportQueryService.getAllReports(request).then(
      (res) => {
        if (res.statusCode === 'S0000' && res.data) {
          // 處理報告列表
          if (res.data.hcreportList.length === 0) {
            // 處理無報告的狀況
            this.noData = true;
          } else {
            // 待後端開發完成
            this.allReports = res.data.hcreportList.sort((a, b) => {
              return b.bookDate.localeCompare(a.bookDate);
            });
            this.noData = false;
          }
        }
      },
      (error) => {
        console.error('查詢所有報告失敗', error);
      }
    );
  }

  // 取得當前選中分類是否有異常
  get selectedCategoryHasAlert(): boolean {
    const category = this.examCategories.find(c => c.examItem === this.selectedCategory);
    return category?.hasAlert ?? false;
  }

  // 導轉回首頁
  navigateHome() {
    this.sharedStorageService.clear(); // 清除暫存資料
    this.router.navigate(['/healthcheck']).then();
  }
}
